import './styles.scss';

import { ForwardedRef, ReactElement, forwardRef } from 'react';

import { ColorInputTypes } from '@/common/ColorInput/types';
import Input from '@/common/Input';
import { getClasses } from '@/utils';

const ColorInput = forwardRef(
  (
    { value, swatches = [], onChange, isValid, isInvalid, isDirty, className }: ColorInputTypes.Props,
    ref: ForwardedRef<ColorInputTypes.RefType>
  ): ReactElement => (
    <div
      ref={ref}
      className={getClasses(
        'ColorInput',
        'Common',
        'form-control',
        isValid ? 'is-valid' : isInvalid ? 'is-invalid' : undefined,
        isDirty ? 'is-dirty' : undefined,
        className
      )}
    >
      {swatches.length > 0 && (
        <>
          <div className="ColorInput-Swatches">
            {swatches.map((color) => (
              <button
                key={color}
                type="button"
                className={getClasses('ColorInput-Swatch', { active: value?.toLowerCase() === color.toLowerCase() })}
                style={{ backgroundColor: color }}
                aria-label={`Select color ${color}`}
                aria-pressed={value?.toLowerCase() === color.toLowerCase()}
                onClick={() => onChange(color)}
              />
            ))}
          </div>
          <span className="ColorInput-Separator">|</span>
          <span className="ColorInput-CustomLabel">Custom:</span>
        </>
      )}
      <Input type="color" className="ColorInput-Input" value={value || '#000000'} onChange={(value): void => onChange(value as string)} />
    </div>
  )
);
ColorInput.displayName = 'ColorInput';

export default ColorInput;
